export default "__VITE_ASSET__DHlaHSqq__"